import styled from 'styled-components';

export const DetailsCards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1.5rem;
  .ant-card-bordered {
    flex: 1 1 12.5rem;
    &:nth-child(2) {
      margin: 0 1.25rem;
    }
  }

  .ant-card-head-title {
    font-weight: bold;
  }
`;
